export default "__VITE_ASSET__Bc1b90GH__"